import * as React from 'react';
import { BaSeParagraph, BaSeTheme } from '@base/react';
import { BaSeButton, BaSeDialogContext, BaSeOptionPicker } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import { CERTIFICADO_TEMPLATE } from '../../hooks/constants';
import { DeleteContent } from '../product/modal/delete';
import { avaliableActions } from '../../models/actions';
import { WrapperActionButtons, WrapperInfo } from './template-certificados-styled';

export const TemplateDefault = ({
  notify,
  onClose,
  handleConfirm,
  isDelete,
  idTemplate,
  listTemplates,
  handleDelete,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);
  const [template, setTemplate] = React.useState(null);
  const [templatesInUse, setTemplatesInUse] = React.useState(0);
  const [loading, setLoading] = React.useState(-1);

  const { backendGet } = Sebrae.useBackend();
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { cinzaSebrae45 } = BaSeTheme.colors.institucionais;

  const messageDelete = React.useMemo(
    () => [
      'Tem certeza que deseja excluir esse template de certificado?',
      'Não será possível recuperar.',
    ],
    [],
  );

  const plural = React.useCallback(
    (item) => (templatesInUse > 1 ? item : ''),
    [templatesInUse],
  );

  const handleSave = React.useCallback(async () => {
    setLoading(0);
    const dtoTemplate = !!template?.length
      ? {
          id: template[0].id,
          descricao: template[0].label,
        }
      : null;

    const { sucess, message } = isDelete
      ? !!templatesInUse
        ? await handleConfirm(idTemplate, dtoTemplate)
        : await handleDelete(idTemplate)
      : await handleConfirm(selectedTemplate);
    if (sucess) {
      notify({
        message: `Dados ${isDelete ? 'excluídos' : 'salvos'} com sucesso!`,
        color: 'confirmation',
      });
      setLoading(-1);
      return onClose?.closeModal?.();
    } else {
      notify({
        message,
        color: 'destructive',
      });
    }
    setLoading(false);
  }, [
    handleConfirm,
    handleDelete,
    idTemplate,
    isDelete,
    notify,
    onClose,
    selectedTemplate,
    template,
    templatesInUse,
  ]);

  React.useEffect(() => {
    setLoading(0);
    if (isDelete) {
      backendGet(
        `${CERTIFICADO_TEMPLATE}/${idTemplate}/quantidade-certificados`,
      )
        .then(setTemplatesInUse)
        .catch((error) =>
          showNotification({
            message:
              'Não foi possível recuperar a lista de templates de certificado!',
            color: 'destructive',
          }),
        )
        .finally(() => setLoading(-1));
    } else {
      backendGet(`${CERTIFICADO_TEMPLATE}/padrao`)
        .then((data) => setSelectedTemplate(data?.id ?? ''))
        .catch((error) =>
          showNotification({
            message: 'Não foi possível recuperar template padrão!',
            color: 'destructive',
          }),
        )
        .finally(() => setLoading(-1));
    }
  }, [backendGet, idTemplate, isDelete, showNotification]);

  return (
    <>
      <WrapperInfo>
        {isDelete && !!templatesInUse && (
          <>
            <BaSeParagraph color={cinzaSebrae45}>
              {`Existe${plural('m')} ${templatesInUse} certificado${plural(
                's',
              )} gerado${plural('s')} usando esse template.`}
            </BaSeParagraph>
            <BaSeParagraph color={cinzaSebrae45}>
              Defina abaixo o template que deverá ser utilizado por esses
              certificados após a exclusão.
            </BaSeParagraph>
          </>
        )}
        {!isDelete && (
          <BaSeParagraph color={cinzaSebrae45}>
            Selecione abaixo o template de certificado que deverá ser usado
            quando nenhum template for selecionado durante a geração.
          </BaSeParagraph>
        )}
      </WrapperInfo>
      {(!!templatesInUse || !isDelete) && (
        <div style={{ margin: '20px 0' }}>
          <BaSeOptionPicker
            color="default"
            emptyValueLabel="Selecione"
            enableSelectAll
            initialSelectedValuesId={[selectedTemplate]}
            label="Novo template"
            maxMenuHeight="100px"
            maxOptionsSelected={1}
            onChange={(item) => {
              setSelectedTemplate(item?.[0]?.id);
              setTemplate(item);
            }}
            overrideColors={{
              moreInfo: BaSeTheme.colors.feedbackInterface.erro35,
            }}
            searchPlaceholder="Procurar template"
            size="medium"
            values={listTemplates}
            width={350}
          />
        </div>
      )}
      <div
        style={{
          padding:
            isDelete && !!templatesInUse
              ? '40px 0 20px'
              : isDelete && !templatesInUse
              ? '0'
              : '40px 0',
        }}
      >
        {isDelete && <DeleteContent texts={messageDelete} />}
      </div>
      <WrapperActionButtons>
        <BaSeButton
          isLoading={loading === 0}
          isDisabled={!selectedTemplate && !!templatesInUse}
          color={BaSeTheme.colors.institucionais.azulSebrae36}
          value={
            isDelete ? avaliableActions.confirmar : avaliableActions.salvar
          }
          onClick={handleSave}
        />
        <BaSeButton
          type="secondary"
          color={BaSeTheme.colors.institucionais.azulSebrae36}
          value={
            isDelete ? avaliableActions.desistir : avaliableActions.cancelar
          }
          onClick={() => onClose?.closeModal?.()}
        />
      </WrapperActionButtons>
    </>
  );
};
